var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$getConstRole('ROLE_OPERATIONS') == _vm.role)?_c('OperationsDeliverOrderView'):_vm._e(),(_vm.$getConstRole('ROLE_ADMIN') == _vm.role)?_c('AdminDeliverOrderView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }